<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header" style="padding: 0px !important">
                <div class="page-breadcrumb">
                    <div class="row">
                        <div class="col-5 align-self-center">
                            <h4 class="page-title">{{ $t("lang.label_rtrant_info") }}</h4>
                        </div>
                        <div class="col-7 align-self-center">
                            <div class="d-flex align-items-right justify-content-end">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <button
                                                @click="SaveRestaurant"
                                                class="btn btn-success btn-sm mr-2"
                                            >
                                                <i class="fas fa-save"></i> {{ btnName }}
                                            </button>
                                        </li>
                                        <li class="breadcrumb-item">
                                            <router-link
                                                :to="{ name: 'Setup' }"
                                                class="btn btn-info btn-sm mr-2"
                                                ><i class="fas fa-arrow-left"></i>
                                                {{ $t("lang.label_back") }}</router-link
                                            >
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="load" v-if="isloading"><loader></loader></div>
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <form class="form-rest" @submit.prevent="SaveRestaurant">
                            <div class="form-row">
                                <div class="form-group col-md-2">
                                    <div>
                                        <img
                                            :src="url + reg.logo"
                                            v-if="reg.is_filel !== false"
                                            class="profile"
                                            style="cursor: pointer"
                                            @click="ShowImageLogo()"
                                        />
                                        <span class="profile" v-else
                                            ><span class="avatar">{{
                                                nameInitial
                                            }}</span></span
                                        >
                                    </div>
                                </div>
                                <div class="form-group col-md-5">
                                    <label for="url">{{ $t("lang.label_name") }}:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="Name"
                                        v-model="reg.name"
                                        maxlength="100"
                                        required
                                    />
                                </div>
                                <div class="form-group col-md-5">
                                    <label for="url">URL:</label>
                                    <div class="input-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="url"
                                            v-model="reg.url"
                                            v-on:keyup="slugUrl"
                                            maxlength="100"
                                            required
                                            style="width: 80% !important;"
                                        />
                                        <div class="input-group-prepend">
                                            <div
                                                class="input-group-text btn-external-link"
                                                @click="external_link(reg.url)"
                                            >
                                                <i
                                                    class="fas fa-external-link-square-alt fa-lg"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="city"
                                        >{{ $t("lang.label_website_menu_link") }}:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="websitemenulink"
                                        v-model="reg.websitemenulink"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="description"
                                        >{{ $t("lang.label_description") }}:
                                        <small
                                            >({{ $t("lang.label_max_caracter") }})</small
                                        ></label
                                    >
                                    <textarea
                                        class="form-control"
                                        row="4"
                                        v-model="reg.description"
                                        maxlength="155"
                                    >
Pmt Method</textarea
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-3">
                                    <label for="city"
                                        >{{ $t("lang.label_telephone") }}:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="telephone"
                                        v-model="reg.telephone"
                                    />
                                </div>
                                <div class="form-group col-md-9">
                                    <label for="address"
                                        >{{ $t("lang.label_adress") }}:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="address"
                                        v-model="reg.address"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="city">{{ $t("lang.label_city") }}:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="city"
                                        v-model="reg.city"
                                    />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="state"
                                        >{{ $t("lang.label_state") }}:</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="state"
                                        v-model="reg.state"
                                    />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="zip">{{ $t("lang.label_zip") }}:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="zip"
                                        v-model="reg.zip"
                                    />
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                            style="width: 100%"
                                        >
                                            <div style="width: 90%">
                                                <label for="inputAddress2"
                                                    >{{ $t("lang.label_gmap_c") }}:</label
                                                >
                                                <textarea
                                                    class="form-control"
                                                    id="exampleFormControlTextarea1"
                                                    rows="2"
                                                    v-model="reg.google_map_code"
                                                ></textarea>
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch09"
                                                        class="onoffswitch-checkbox"
                                                        id="onoffswitch09"
                                                        tabindex="0"
                                                        v-model="reg.google_map_display"
                                                        :checked="reg.google_map_display"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="onoffswitch09"
                                                        v-if="status === 0"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-en"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-en"
                                                        ></span>
                                                    </label>
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="onoffswitch09"
                                                        v-else
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-es"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-es"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                            style="width: 100%"
                                        >
                                            <div class="inputs_fb" style="width: 90%">
                                                <label for="inputCity">Facebook:</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="reg.facebook_user"
                                                />
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch01"
                                                        class="onoffswitch-checkbox"
                                                        id="onoffswitch01"
                                                        tabindex="0"
                                                        v-model="reg.facebook_display"
                                                        :checked="reg.facebook_display"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="onoffswitch01"
                                                        v-if="status === 0"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-en"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-en"
                                                        ></span>
                                                    </label>
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="onoffswitch01"
                                                        v-else
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-es"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-es"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                            style="width: 100%"
                                        >
                                            <div class="inputs_fb" style="width: 90%">
                                                <label for="inputCity">Instagram:</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="reg.instagram_user"
                                                />
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch"
                                                        class="onoffswitch-checkbox"
                                                        id="myonoffswitch1"
                                                        tabindex="0"
                                                        v-model="reg.instagram_display"
                                                        :checked="reg.instagram_display"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="myonoffswitch1"
                                                        v-if="status === 0"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-en"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-en"
                                                        ></span>
                                                    </label>
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="myonoffswitch1"
                                                        v-else
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-es"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-es"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                            style="width: 100%"
                                        >
                                            <div class="inputs_fb" style="width: 90%">
                                                <label for="inputCity">Whatsapp:</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="reg.whatsapp"
                                                />
                                            </div>
                                            <div class="inputs_swich">
                                                <div class="onoffswitch">
                                                    <input
                                                        type="checkbox"
                                                        name="onoffswitch2"
                                                        class="onoffswitch-checkbox"
                                                        id="myonoffswitch2"
                                                        tabindex="0"
                                                        v-model="reg.whatsapp_display"
                                                        :checked="reg.whatsapp_display"
                                                    />
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="myonoffswitch2"
                                                        v-if="status === 0"
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-en"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-en"
                                                        ></span>
                                                    </label>
                                                    <label
                                                        class="onoffswitch-label"
                                                        for="myonoffswitch2"
                                                        v-else
                                                    >
                                                        <span
                                                            class="onoffswitch-inner-es"
                                                        ></span>
                                                        <span
                                                            class="onoffswitch-switch-es"
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12" v-if="langLocal === 'es'">
                                    <div class="form-row">
                                        <div
                                            class="d-flex justify-content-between align-items-end"
                                            style="width: 100%"
                                        >
                                            <div class="inputs_fb" style="width: 100%">
                                                <label for="inputCity"
                                                    >C&oacute;digo de Chat:</label
                                                >
                                                <textarea
                                                    class="form-control"
                                                    row="4"
                                                    v-model="reg.widget_chat"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" style="margin-top: 20px">
                                        <label for="inputZip">Logo:</label>
                                        <input
                                            type="file"
                                            class="form-control-file"
                                            id="img_logo"
                                            name="img_logo"
                                            v-on:change="uploadFile"
                                            ref="logo"
                                            accept="image/jpeg,image/jpg"
                                        />
                                    </div>
                                    <div class="thumbnail poster-fb">
                                        <div
                                            v-bind:class="[
                                                { noneImg: reg.is_filel === false },
                                                '',
                                            ]"
                                        >
                                            <div class="btns_action">
                                                <a
                                                    @click="deleteImage(1)"
                                                    class="btn btn-danger deleteImg"
                                                    style="color: #fff; font-size: 14px"
                                                    ><i class="fas fa-times"></i
                                                ></a>
                                            </div>
                                            <img
                                                :src="url + reg.logo"
                                                alt="poster"
                                                style="width: 100%; cursor: pointer"
                                                @click="ShowImageLogo()"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" style="margin-top: 21px">
                                        <label for="inputZip"
                                            >{{ $t("lang.label_cover") }}:</label
                                        >
                                        <input
                                            type="file"
                                            class="form-control-file"
                                            id="img_cover"
                                            name="img_cover"
                                            v-on:change="uploadFile2"
                                            accept="image/jpeg,image/jpg"
                                        />
                                    </div>
                                    <div class="thumbnail poster-fb">
                                        <div
                                            v-bind:class="[
                                                { noneImg: reg.is_filec === false },
                                                '',
                                            ]"
                                        >
                                            <div class="btns_action">
                                                <a
                                                    @click="deleteImage(2)"
                                                    class="btn btn-danger deleteImg"
                                                    style="color: #fff; font-size: 14px"
                                                    ><i class="fas fa-times"></i
                                                ></a>
                                            </div>
                                            <img
                                                :src="url + reg.cover"
                                                alt="poster"
                                                style="width: 100%; cursor: pointer"
                                                @click="ShowImageCover()"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="hours_area">
                                <h3>{{ $t("lang.label_hours") }}</h3>
                                <table class="table">
                                    <tbody>
                                        <tr v-for="(i, index) in hours" :key="index">
                                            <th scope="row" style="width: 88px">
                                                <b>{{ i.display }}</b>
                                            </th>
                                            <td style="width: 50px">
                                                <div class="swiches">
                                                    <label class="switch">
                                                        <input
                                                            type="checkbox"
                                                            :checked="i.hStatus"
                                                            v-model="hours[index].hStatus"
                                                        />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </td>
                                            <td style="width: 50px">
                                                <span
                                                    style="color: #5ac146"
                                                    v-if="i.hStatus"
                                                    >{{ $t("lang.label_open") }}</span
                                                ><span style="color: #444" v-else>{{
                                                    $t("lang.label_closed")
                                                }}</span>
                                            </td>
                                            <td style="width: 140px">
                                                <div class="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        :class="[
                                                            'form-control',
                                                            i.error1 === true &&
                                                            i.hStatus === true
                                                                ? 'is-invalid'
                                                                : '',
                                                        ]"
                                                        id="Sunday_one"
                                                        v-model="i.one"
                                                        placeholder="00:00"
                                                        :disabled="!i.hStatus"
                                                        style="width: 70px"
                                                    />
                                                    <span style="padding-left: 4px">
                                                        <select
                                                            v-model="hours[index].hOne"
                                                            :disabled="!i.hStatus"
                                                            class="form-control"
                                                            style="width: 70px"
                                                        >
                                                            <option value="1">AM</option>
                                                            <option value="2">PM</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </td>
                                            <td style="width: 140px">
                                                <div class="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        :class="[
                                                            'form-control',
                                                            i.error2 === true &&
                                                            i.hStatus === true
                                                                ? 'is-invalid'
                                                                : '',
                                                        ]"
                                                        id="Sunday_two"
                                                        v-model="i.two"
                                                        placeholder="00:00"
                                                        :disabled="!i.hStatus"
                                                        style="width: 70px"
                                                    />
                                                    <span style="padding-left: 4px">
                                                        <select
                                                            v-model="hours[index].hTwo"
                                                            :disabled="!i.hStatus"
                                                            class="form-control"
                                                            style="width: 70px"
                                                        >
                                                            <option value="1">AM</option>
                                                            <option value="2">PM</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <div class="d-flex align-items-center justify-content-center" style="background-color:#ececec;padding:10px;">
                <div style="padding-right:8px;">
                 {{$t("lang.msj_info_wget")}}
                </div>
                <div class="swiches">
                  <label class="switch">
                    <input type="checkbox" name="showInfo" :checked="reg.shoInWidget" v-model="reg.showInWidget">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div> -->
                            <hr />
                            <div
                                class="d-flex align-items-center justify-content-center"
                                style="margin-top: 20px"
                            >
                                <button type="submit" class="btn btn-success">
                                    <i class="fas fa-save"></i> {{ btnName }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <modal
            name="logo"
            height="auto"
            width="700px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            :min-height="400"
        >
            <div class="card-header">
                Logo
                <button @click="closeModalLogo" class="closeIcon"><span></span></button>
            </div>
            <div class="card-body">
                <img
                    :src="url + reg.logo"
                    alt=""
                    style="
                        text-align: center;
                        display: block;
                        margin: 0px auto;
                        max-width: 100%;
                    "
                />
            </div>
        </modal>
        <modal
            name="cover"
            height="auto"
            width="700px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            :min-height="400"
        >
            <div class="card-header">
                {{ $t("lang.label_cover") }}
                <button @click="closeModalCover" class="closeIcon"><span></span></button>
            </div>
            <div class="card-body">
                <img
                    :src="url + reg.cover"
                    alt=""
                    style="
                        text-align: center;
                        display: block;
                        margin: 0px auto;
                        max-width: 100%;
                    "
                />
            </div>
        </modal>
        <notifications group="noti" position="top right" style="margin-top: 50px">
        </notifications>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "RestaurantView",
    components: {
        Loader,
    },
    data () {
        return {
            isloading: false,
            restaurants: [],
            reg: {
                id: null,
                name: "",
                url: "",
                telephone: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                google_map_code: "",
                google_map_display: false,
                facebook_user: null,
                facebook_display: true,
                instagram_user: null,
                instagram_display: true,
                whatsapp: null,
                whatsapp_display: true,
                cover: "",
                coverOld: null,
                logo: "",
                logoOld: null,
                is_file: false,
                showInWidget: true,
                description: "",
                swich: "",
                org_id: window.localuserdata,
                user_id: window.localAccountID,
                widget_chat: "",
                websitemenulink: "",
            },
            url: null,
            hours: [],
            nameInitial: null,
            restInfo: null,
            btnName: window.lang2.label_save,
            countName: "",
            hourx: [],
            status: parseInt(window.lang2.label_IE),
            langLocal: window.langLocal,
        };
    },
    created () {
        this.getInfo();
        // this.changeFormat()
    },
    mounted () {
        this.reg.name = localStorage.getItem("nomCompany") || "";
    },
    methods: {
        changeFormat(str) {
            return new Promise(function (resolve, reject) {
                // let str = "013";
                str = str.replace(/^\s+|\s+$/g, "");
                str = str.toLowerCase();
                var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
                var to = "aaaaaeeeeeiiiiooooouuuunc------";
                for (var i = 0, l = from.length; i < l; i++) {
                    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
                }
                str = str
                    .replace(/[^a-z0-9 -]/g, "")
                    .replace(/\s+/g, "")
                    .replace(/-+/g, "");
                let num = parseInt(str);
                if (num > 2400) {
                    str = "error no puede ser mayor que 2400";
                    reject(str); // ¡Todo salió mal!
                } else {
                    let count = str.length;
                    if (count === 1) {
                        str = "0" + str.slice(0, 2) + ":00";
                    } else if (count === 2) {
                        str = str.slice(0, 2) + ":00";
                    } else if (count === 3) {
                        str = str.slice(0, 2) + ":" + str.slice(2) + "0";
                    } else {
                        str = str.slice(0, 2) + ":" + str.slice(2);
                    }
                    resolve(str); // ¡Todo salió bien!
                }
            });
        },
        deleteImage(a) {
            this.reg.swich = a;
            this.$swal({
                title: window.lang2.label_del_img + "?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    let url = "/menu/del";
                    window.master
                        .post(url, this.reg)
                        .then((response) => {
                            let result = response.data;
                            console.log(result);
                            this.getInfo();
                            this.isLoading = false;
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            console.log(error);
                        });
                }
            });
        },
        ShowImageLogo(i) {
            this.$modal.show("logo");
            this.image_preview_logo = this.url + this.reg.logo;
        },
        closeModalLogo() {
            this.$modal.hide("logo");
        },
        ShowImageCover(i) {
            this.$modal.show("cover");
            this.image_preview_cover = this.url + this.reg.cover;
        },
        closeModalCover() {
            this.$modal.hide("cover");
        },
        external_link(url) {
            if (url.length > 0) {
                window.open(window.urlweb + url, "_blank");
            }
        },
        slugUrl(event) {
            let str = event.currentTarget.value;
            str = str.replace(/^\s+|\s+$/g, "");
            str = str.toLowerCase();

            var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
            var to = "aaaaaeeeeeiiiiooooouuuunc------";
            for (var i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }
            str = str
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");
            this.reg.url = str;
        },
        slugUrl1(slug) {
            let str = slug;
            str = str.replace(/^\s+|\s+$/g, "");
            str = str.toLowerCase();

            var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
            var to = "aaaaaeeeeeiiiiooooouuuunc------";
            for (var i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
            }
            str = str
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");

            return str;
        },
        uploadFile(e) {
            this.reg.logo = e.target.files[0];
        },
        uploadFile2(e) {
            this.reg.cover = e.target.files[0];
        },
        getInfo() {
            let org_id = window.localuserdata;
            let user_id = window.localAccountID;
            this.isloading = true;
            window.master
                .get("menu/information/" + user_id + "/" + org_id)
                .then((response) => {
                    let dia = [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                    ];
                    let da = [
                        "Domingo",
                        "Lunes",
                        "Martes",
                        "Miercoles",
                        "Jueves",
                        "Viernes",
                        "Sabado",
                    ];
                    console.log(response.data.result);
                    if (response.data.status === true) {
                        this.reg.id = response.data.result.id;
                        this.reg.is_filel = response.data.is_filel;
                        this.reg.is_filec = response.data.is_filec;
                        this.reg.logo = response.data.result.logo;
                        this.reg.logoOld =
                            response.data.result.logo === null ||
                            response.data.result.logo === "null"
                                ? null
                                : response.data.result.logo;
                        this.reg.coverOld = response.data.result.cover;
                        this.reg.cover = response.data.result.cover;
                        this.url = response.data.url;
                        this.reg.name = response.data.result.name === null ||
                                response.data.result.name === "null"
                                ? ""
                                : response.data.result.name;

                        this.reg.url =
                            response.data.result.url === "null"
                                ? ""
                                : response.data.result.url;                        
                        this.countName = this.reg.name.length;
                        this.reg.telephone =
                            response.data.result.telephone === "null"
                                ? ""
                                : response.data.result.telephone;
                        this.reg.address =
                            response.data.result.address === null ||
                            response.data.result.address === "null"
                                ? ""
                                : response.data.result.address;
                        this.reg.city =
                            response.data.result.city === null ||
                            response.data.result.city === "null"
                                ? ""
                                : response.data.result.city;
                        this.reg.state =
                            response.data.result.state === null ||
                            response.data.result.state === "null"
                                ? ""
                                : response.data.result.state;
                        this.reg.zip =
                            response.data.result.zip === null ||
                            response.data.result.zip === "null"
                                ? ""
                                : response.data.result.zip;
                        this.reg.google_map_code =
                            response.data.result.google_map_code === null ||
                            response.data.result.google_map_code === "null"
                                ? ""
                                : response.data.result.google_map_code;
                        this.reg.facebook_user =
                            response.data.result.facebook_user === "null"
                                ? ""
                                : response.data.result.facebook_user;
                        this.reg.facebook_display =
                            response.data.result.facebook_display === 1 ? true : false;
                        this.reg.instagram_user =
                            response.data.result.instagram_user === "null"
                                ? ""
                                : response.data.result.instagram_user;
                        this.reg.instagram_display =
                            response.data.result.instagram_display === 1 ? true : false;
                        this.reg.showInWidget =
                            response.data.result.show_in_widget === 1 ? true : false;
                        let dataH = response.data.result.hours;
                        this.reg.description =
                            response.data.result.description === null ||
                            response.data.result.description === "null"
                                ? ""
                                : response.data.result.description;                            
                        this.reg.whatsapp =
                            response.data.result.whatsapp === "null"
                                ? ""
                                : response.data.result.whatsapp;
                        this.reg.whatsapp_display =
                            response.data.result.whatsapp_display === 1 ? true : false;
                        this.reg.websitemenulink = 
                            response.data.result.website_menu_link === null ||
                            response.data.result.website_menu_link === "null"
                                ? ""
                                : response.data.result.website_menu_link;                        
                        this.reg.widget_chat =
                            response.data.result.widget_chat === null ||
                            response.data.result.widget_chat === "null"
                                ? ""
                                : response.data.result.widget_chat;                         
                        this.reOrden(dataH, dia, da);
                    } else {
                        this.reg.is_filel = response.data.is_filel;
                        this.reg.is_filec = response.data.is_filec;
                        this.reOrdenDefault(dia, da);
                    }
                    this.isloading = false;
                })
                .catch((error) => {
                    this.isloading = false;
                });
        },
        reOrdenDefault(dia, da) {
            //sino existe horari generamos defult
			let hours = []
            if (window.lang2.label_IE === 1 || window.lang2.label_IE === "1") {
                for (let i = 0; i <= 6; i++) {
                    if (i > 0) {
                        let kd = da[i];
                        let day_display = da[i];
                        hours.push({
                            hStatus: false,
                            display: day_display,
                            name: da[i].toLowerCase(),
                            one: "07:00",
                            hOne: 1,
                            two: "06:00",
                            hTwo: 2,
                            error1: false,
                            error2: false,
                        });
                    }
                }
                let kd = da[0];
                let day_display = da[0];
                hours.push({
                    hStatus: false,
                    display: day_display,
                    name: da[0].toLowerCase(),
                    one: "07:00",
                    hOne: 1,
                    two: "06:00",
                    hTwo: 2,
                    error1: false,
                    error2: false,
                });
            } else {
                for (let i = 0; i <= 6; i++) {
                    if (i > 0) {
                        let day_display = dia[i];
                        let d = dia[i].toLowerCase();
                        this.hours.push({
                            hStatus: false,
                            display: day_display,
                            name: d,
                            one: "07:00",
                            hOne: 1,
                            two: "06:00",
                            hTwo: 2,
                            error1: false,
                            error2: false,
                        });
                    }
                }
                let day_display = dia[0];
                let d = dia[0].toLowerCase();
                hours.push({
                    hStatus: false,
                    display: day_display,
                    name: d,
                    one: "07:00",
                    hOne: 1,
                    two: "06:00",
                    hTwo: 2,
                    error1: false,
                    error2: false,
                });
            }
            // console.log(hours);
        },
        reOrden(dataH, dia, da) {
            let hours = [];
            if (window.lang2.label_IE === 1 || window.lang2.label_IE === "1") {
                for (let i = 0; i <= 6; i++) {
                    if (i > 0) {
                        let d = dia[i].toLowerCase();
                        let day_display = da[i];
                        let hStatusValue = dataH[d + "_display"] === 1 ? true : false;
                        let oneValue = dataH[d + "_hour_one"]; //saturday_hour_one
                        let hOneValue = dataH[d + "_hOne"]; //saturday_hOne
                        let twoValue = dataH[d + "_hour_two"]; //saturday_hour_two
                        let hTwoValue = dataH[d + "_hTwo"]; //saturday_hTwo
                        hours.push({
                            hStatus: hStatusValue,
                            display: day_display,
                            name: da[i].toLowerCase(),
                            one: oneValue,
                            hOne: hOneValue,
                            two: twoValue,
                            hTwo: hTwoValue,
                            error1: false,
                            error2: false,
                        });
                    }
                }
                let d = dia[0].toLowerCase();
                let day_display = da[0];
                let hStatusValue = dataH[d + "_display"] === 1 ? true : false;
                let oneValue = dataH[d + "_hour_one"]; //saturday_hour_one
                let hOneValue = dataH[d + "_hOne"]; //saturday_hOne
                let twoValue = dataH[d + "_hour_two"]; //saturday_hour_two
                let hTwoValue = dataH[d + "_hTwo"]; //saturday_hTwo
                hours.push({
                    hStatus: hStatusValue,
                    display: day_display,
                    name: da[0].toLowerCase(),
                    one: oneValue,
                    hOne: hOneValue,
                    two: twoValue,
                    hTwo: hTwoValue,
                    error1: false,
                    error2: false,
                });
            } else {
                for (let i = 0; i <= 6; i++) {
                    if (i > 0) {
                        let d = dia[i].toLowerCase();
                        let day_display = dia[i];
                        let hStatusValue = dataH[d + "_display"] === 1 ? true : false;
                        let oneValue = dataH[d + "_hour_one"]; //saturday_hour_one
                        let hOneValue = dataH[d + "_hOne"]; //saturday_hOne
                        let twoValue = dataH[d + "_hour_two"]; //saturday_hour_two
                        let hTwoValue = dataH[d + "_hTwo"]; //saturday_hTwo
                        hours.push({
                            hStatus: hStatusValue,
                            display: day_display,
                            name: d,
                            one: oneValue,
                            hOne: hOneValue,
                            two: twoValue,
                            hTwo: hTwoValue,
                            error1: false,
                            error2: false,
                        });
                    }
                }
                let d = dia[0].toLowerCase();
                let day_display = dia[0];
                let hStatusValue = dataH[d + "_display"] === 1 ? true : false;
                let oneValue = dataH[d + "_hour_one"]; //saturday_hour_one
                let hOneValue = dataH[d + "_hOne"]; //saturday_hOne
                let twoValue = dataH[d + "_hour_two"]; //saturday_hour_two
                let hTwoValue = dataH[d + "_hTwo"]; //saturday_hTwo
                hours.push({
                    hStatus: hStatusValue,
                    display: day_display,
                    name: dia[0].toLowerCase(),
                    one: oneValue,
                    hOne: hOneValue,
                    two: twoValue,
                    hTwo: hTwoValue,
                    error1: false,
                    error2: false,
                });
            }
            this.hours = hours;
        },
        restData() {
            let dia = [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
            ];
            let da = [
                "Lunes",
                "Martes",
                "Miercoles",
                "Jueves",
                "Viernes",
                "Sabado",
                "Domingo",
            ];
            let com = [];
            if (window.lang2.label_IE === 1 || window.lang2.label_IE === "1") {
                com = da;
            } else {
                com = dia;
            }
            this.hourx = [];
            let t = this.hours;
            var cam = {};
            for (const i in t) {
                if (com[i] === t[i].display) {
                    let d = dia[i].toLowerCase();
                    cam[d + "_display"] = t[i].hStatus;
                    cam[d + "_hOne"] = t[i].hOne;
                    cam[d + "_hTwo"] = t[i].hTwo;
                    cam[d + "_hour_one"] = t[i].one;
                    cam[d + "_hour_two"] = t[i].two;
                }
            }
            this.hourx = JSON.stringify(cam);
        },
        SaveRestaurant() {
            this.restData();
            let errors = false;
            let re = this.hours.length;
            for (let i in this.hours) {
                if (this.hours[i].hStatus === true) {
                    if (this.hours[i].one === null || this.hours[i].one.length === 0) {
                        this.hours[i].error1 = true;
                        errors = true;
                    }
                    if (this.hours[i].two === null || this.hours[i].two.length === 0) {
                        this.hours[i].error2 = true;
                        errors = true;
                    }
                } else {
                    if (this.hours[i].one === null || this.hours[i].one.length === 0) {
                        this.hours[i].error1 = false;
                        this.hours[i].one = "07:00";
                        this.hours[i].hOne = 1;
                    }
                    if (this.hours[i].two === null || this.hours[i].two.length === 0) {
                        this.hours[i].error2 = false;
                        this.hours[i].two = "06:00";
                        this.hours[i].hTwo = 2;
                    }
                }
                this.changeFormat(this.hours[i].one)
                    .then((response) => {
                        console.log("one" + response);
                    })
                    .catch((error) => {
                        console.log("one" + error);
                    });
                this.changeFormat(this.hours[i].two)
                    .then((response) => {
                        console.log("two" + response);
                    })
                    .catch((error) => {
                        console.log("two" + error);
                    });
            }
            this.isloading = true;
            if (errors === true) {
                console.log("error");
                this.isloading = false;
                this.btnName = window.lang2.label_save;
            } else {
                this.btnName = window.lang2.label_upd + "...";
                let facebook_display = 0;
                let instagram_display = 0;
                let whatsapp_display = 0;
                let show_in_widget = 0;
                let google_map_display = 0;
                if (this.reg.google_map_display) {
                    google_map_display = 1;
                }
                if (this.reg.facebook_display) {
                    facebook_display = 1;
                }
                if (this.reg.instagram_display) {
                    instagram_display = 1;
                }
                if (this.reg.whatsapp_display) {
                    whatsapp_display = 1;
                }
                if (this.reg.showInWidget) {
                    show_in_widget = 1;
                }
                let fileSendHeader = {
                    headers: { "Content-Type": "multipart/form-data" },
                };                
                let formData = new FormData();
                //formData.append("file", this.menu_item.menu_image);
                //formData.append("image", this.imageActiveFood);
                formData.append("id", this.reg.id);
                formData.append("name", this.reg.name);
                formData.append("url", this.reg.url);
                formData.append("telephone", this.reg.telephone);
                formData.append("address", this.reg.address);
                formData.append("city", this.reg.city);
                formData.append("state", this.reg.state);
                formData.append("zip", this.reg.zip);
                formData.append("google_map_code", this.reg.google_map_code);
                formData.append("google_map_display", google_map_display);
                formData.append("facebook_user", this.reg.facebook_user);
                formData.append("facebook_display", facebook_display);
                formData.append("instagram_user", this.reg.instagram_user);
                formData.append("instagram_display", instagram_display);
                formData.append("coverOld", this.reg.coverOld);
                formData.append("cover", this.reg.cover);
                formData.append("logo", this.reg.logo);
                formData.append("logoOld", this.reg.logoOld);
                formData.append("show_in_widget", show_in_widget);
                formData.append("org_id", window.localuserdata);
                formData.append("user_id", window.localAccountID);
                formData.append("hours", JSON.stringify(this.hours));
                formData.append("cnn", this.hourx);
                formData.append("description", this.reg.description);
                formData.append("whatsapp", this.reg.whatsapp);
                formData.append("whatsapp_display", whatsapp_display);
                formData.append("websitemenulink", this.reg.websitemenulink);
                formData.append("widget_chat", this.reg.widget_chat);
                window.master
                    .post("restaurants/add", formData, fileSendHeader)
                    .then((response) => {
                        this.isloading = false;
                        if (this.reg.websitemenulink.length > 0) {
                            this.$store.commit(
                                "set_urlWebDimenu",
                                this.reg.websitemenulink
                            );
                        }
                        this.btnName = window.lang2.label_saved;
                        if (
                            response.data.image_large === true &&
                            response.data.status === false
                        ) {
                            this.$notify({
                                group: "noti",
                                title: "ERROR",
                                type: "error",
                                text: window.lang2.msj_img_err,
                            });
                        } else if (
                            response.data.image_large === false &&
                            response.data.status === true
                        ) {
                            this.$notify({
                                group: "noti",
                                title: window.lang2.label_up,
                                type: "success",
                                text: window.lang2.msj_info_updd_sful,
                            });
                        }
                        this.getInfo();
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.btnName = window.lang2.label_save;
                    });
            }
        },
        // OpenHours() {
        //   this.$modal.show("modal-hours");
        // },
        // OpenNew() {
        //   this.$modal.show("modal-restaurant");
        // },
        // closeModal() {
        //   this.$modal.hide("modal-hours");
        // },
    },
    watch: {
        "reg.name": function () {
            if (this.reg.name.length > 0 && this.reg.name !== null) {
                this.nameInitial = this.reg.name.charAt().toUpperCase();
            }
            if (this.countName !== this.reg.name.length) {
                this.reg.url = this.slugUrl1(this.reg.name);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.btn-external-link:hover {
    cursor: pointer;
}
.is-invalid {
    border-color: #fa5838 !important;
}
.load {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff7a;
    z-index: 10;
    .op-loading {
        height: 100vh;
    }
}
.swiches {
    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 22px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #2196f3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(17px);
        -ms-transform: translateX(17px);
        transform: translateX(17px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
}
.profile {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #ababab;
    color: #fff;
    display: flex;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    margin-top: 10px;
}
.form-rest {
    .form-control {
        border: 1px solid #bfbfbf;
    }
    .form-group {
        margin-bottom: 0.5rem;
    }
}
.onoffswitch {
    position: relative;
    width: 83px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}
.onoffswitch-checkbox {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}
.onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid #ffffff;
    border-radius: 25px;
}
.onoffswitch-inner {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
    display: block;
    float: left;
    width: 50%;
    height: 26px;
    padding: 0;
    line-height: 26px;
    font-size: 13px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner:before {
    content: "Público";
    padding-left: 8px;
    background-color: #82c234;
    color: #ffffff;
}
.onoffswitch-inner:after {
    content: "Privado";
    padding-right: 8px;
    background-color: #eeeeee;
    color: #999999;
    text-align: right;
}
.onoffswitch-switch {
    display: block;
    width: 18px;
    margin: 4px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 53px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px;
}
.page-breadcrumb .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
    content: "";
}
.thumbnail.poster-fb {
    max-width: 135px;
    border-radius: 4px;
    padding: 4px;
}
.thumbnail.poster-fb img {
    border-radius: 4px;
    margin-bottom: 5px;
}
.noneImg {
    display: none;
}
.btns_action {
    display: flex;
    position: absolute;
    a {
        cursor: pointer;
        border-radius: 4px;
    }
}
.deleteImg {
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px 8px;
    font-size: 10px;
    transition: 0.15s padding ease-out, 0.15s margin ease-out, 0.15s border ease-out;
}

.onoffswitch-inner-en {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner-en:before,
.onoffswitch-inner-en:after {
    display: block;
    float: left;
    width: 50%;
    height: 26px;
    padding: 0;
    line-height: 26px;
    font-size: 13px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner-en:before {
    content: "Show";
    padding-left: 8px;
    background-color: #82c234;
    color: #ffffff;
}
.onoffswitch-inner-en:after {
    content: "Hidden";
    padding-right: 8px;
    background-color: #eeeeee;
    color: #999999;
    text-align: right;
}
.onoffswitch-switch-en {
    display: block;
    width: 18px;
    margin: 4px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 53px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner-en {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch-en {
    right: 0px;
}

.onoffswitch-inner-es {
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
}
.onoffswitch-inner-es:before,
.onoffswitch-inner-es:after {
    display: block;
    float: left;
    width: 50%;
    height: 26px;
    padding: 0;
    line-height: 26px;
    font-size: 13px;
    color: white;
    font-family: Trebuchet, Arial, sans-serif;
    font-weight: bold;
    box-sizing: border-box;
}
.onoffswitch-inner-es:before {
    content: "Visible";
    padding-left: 8px;
    background-color: #82c234;
    color: #ffffff;
}
.onoffswitch-inner-es:after {
    content: "Oculto";
    padding-right: 8px;
    background-color: #eeeeee;
    color: #999999;
    text-align: right;
}
.onoffswitch-switch-es {
    display: block;
    width: 18px;
    margin: 4px;
    background: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 53px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner-es {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch-es {
    right: 0px;
}
</style>
